import React from 'react'

import NftAssetCard from '../../StakingConsole/NftAssetCard'

export default function NFTList({ nfts = [], metadataById = {}, selectedTokenId, loading = {}, onSelect, t }) {
    return <div className="nft-asset-grid">
        {nfts.map((item) => {
            const tokenId = String(typeof item === 'object' ? item.id : item)
            const itemMetadata = typeof item === 'object' ? item : {}
            const nft = {
                id: tokenId,
                name: `NFT #${tokenId}`,
                metadataStatus: 'error',
                ...itemMetadata,
                ...(metadataById[tokenId] || {}),
            }
            return <NftAssetCard key={tokenId} nft={nft} selected={selectedTokenId === tokenId} loading={Boolean(loading[tokenId])} onSelect={onSelect} t={t} />
        })}
    </div>
}
